import { createApi } from "@reduxjs/toolkit/query/react";

import baseQuery from "redux/baseQuery";
import { removeCreadential, setCredential } from "redux/slices/user";

import { User, UserCredential } from "./types";

export const apiService = createApi({
    reducerPath: "apiService",
    baseQuery: baseQuery,
    tagTypes: ["menu", "user", "role", "permission", "cctv", "config", "datalake", "database", "organization"],
    endpoints: (build) => ({
        getMe: build.query<User, void>({
            query: () => ({ url: "/users/me" }),
            providesTags: () => [{ type: "user", id: "me" }],
        }),
        login: build.mutation<any, UserCredential>({
            query: ({ email, password }) => ({
                url: "../../../login",
                method: "post",
                data: { email, password },
            }),
            invalidatesTags: () => [{ type: "user", id: "me" }],
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;

                    // ✅ set setelah sukses
                    localStorage.setItem("auth_mode", "password");
                    localStorage.removeItem("sanctum_token"); // optional: bersihin kalau sebelumnya SSO

                    const { data: loggedInUser } = await dispatch(
                        apiService.endpoints.getMe.initiate()
                    );
                    dispatch(setCredential(loggedInUser));
                } catch (error: any) {
                    // optional: bersihin jika login gagal
                    localStorage.removeItem("auth_mode");
                    console.log(error?.error?.data?.message);
                }
            },
        }),

        logout: build.mutation<any, void>({
            query: () => ({
                url: "../../../logout",
                method: "post",
            }),
            invalidatesTags: () => [{ type: "user", id: "me" }],
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;
                } finally {
                    // ✅ bersihkan state lokal
                    localStorage.removeItem("auth_mode");
                    dispatch(removeCreadential());
                }
            },
        }),

        logoutToken: build.mutation<any, void>({
            query: () => ({
                url: "/auth/logout-token",
                method: "post",
            }),
            invalidatesTags: () => [{ type: "user", id: "me" }],
            onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
                try {
                    await queryFulfilled;
                } finally {
                    // ✅ bersihkan local storage & redux
                    localStorage.removeItem("sanctum_token");
                    localStorage.removeItem("auth_mode");
                    dispatch(removeCreadential());
                }
            },
        }),

    }),
});

export const { useLoginMutation, useLogoutMutation, useGetMeQuery, useLogoutTokenMutation } =
    apiService;
